import * as React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftBadge from "components/SoftBadge";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

import Grid from "@mui/material/Grid";
import SoftButton from "components/SoftButton";
import { useEffect } from "react";

function ControlledAccordions({ data, handleChangeConfiguration }) {
  const [expanded, setExpanded] = React.useState(setSelectedPanel());
  const [selected, setSelected] = React.useState(setSelectedPanel());

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSelect = (event, selectedConfig) => {
    setSelected(selectedConfig ? "panel" + selectedConfig.id : false);
    setExpanded(false);
    handleChangeConfiguration(selectedConfig, "preview");
  };

  const handleSave = (event, selectedConfig) => {
    handleChangeConfiguration(selectedConfig, "save");
  };

  function setSelectedPanel() {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const template = data[key];
        template.unused = false;
        for (let index = 0; index < template.details.length; index++) {
          const detail = template.details[index];
          if (
            (detail.name === "Providers" || detail.name === "Sports") &&
            (detail.count === 0 || !detail.count)
          ) {
            template.unused = true;
          }
        }

        if (template.status) {
          return "panel" + template.id;
        }
      }
    }
  }

  useEffect(() => {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const template = data[key];
        template.unused = false;
        for (let index = 0; index < template.details.length; index++) {
          const detail = template.details[index];
          if (
            (detail.name === "Providers" || detail.name === "Sports") &&
            (detail.count === 0 || !detail.count)
          ) {
            template.unused = true;
          }
        }
        if (template.status) {
          setExpanded("panel" + template.id);
          setSelected("panel" + template.id);
          //break;
        }
      }
    }
  }, [data]);

  return (
    <div>
      {data.map((accordionItem) => (
        <Accordion
          className={
            selected === "panel" + accordionItem.id
              ? "accordion-selected"
              : expanded === "panel" + accordionItem.id
              ? "accordion-open"
              : "accordion-closed"
          }
          key={accordionItem.id}
          expanded={expanded === "panel" + accordionItem.id}
          onChange={handleChange("panel" + accordionItem.id)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={"panel" + accordionItem.id + "bh-content"}
            id={"panel" + accordionItem.id + "bh-header"}
          >
            <Typography sx={{ width: "200px", flexShrink: 0, fontSize: "0.95rem" }}>
              {accordionItem.name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid key={accordionItem.id + " " + accordionItem.name} container>
              <Grid item xs={12}>
                <Typography
                  className="template-info"
                  sx={{
                    color: "text.secondary",
                    fontSize: "0.85rem",
                    textAlign: "left",
                    width: "100%",
                    whiteSpace: "normal !important",
                  }}
                >
                  {accordionItem.info}
                </Typography>
              </Grid>
            </Grid>

            <Divider />

            {accordionItem.details.map((filterCategory) => (
              <div key={accordionItem.id + "-" + filterCategory.name + "-holder"}>
                <Grid key={accordionItem.id + " " + filterCategory.name} container spacing={2}>
                  <Grid item xs={4}>
                    <Typography
                      style={{ className: "template-info" }}
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.95rem",
                        textAlign: "left",
                      }}
                    >
                      {filterCategory.name}:
                    </Typography>
                  </Grid>

                  <Grid item xs={8}>
                    {filterCategory.name === "Competitions" ||
                    filterCategory.name === "Disabled Markets" ? (
                      <Typography
                        style={{ className: "template-info" }}
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.95rem",
                          textAlign: "left",
                        }}
                      >
                        {filterCategory.count}
                      </Typography>
                    ) : (
                      <div style={{ flexWrap: "wrap", display: "flex" }}>
                        {filterCategory.value.length > 0
                          ? filterCategory.value.map((item) => (
                              <div
                                key={item}
                                style={{
                                  marginLeft: "0px",
                                  marginTop: "0px",
                                  marginRight: "2px",
                                  marginBottom: "2px",
                                  padding: "0px",
                                  maxWidth: "fit-content",
                                  marginRight: "2px",
                                  maxHeight: "20px",
                                }}
                              >
                                <SoftBadge
                                  badgeContent={item}
                                  color={filterCategory.name === "Providers" ? "primary" : "info"}
                                  size="xs"
                                  variant={
                                    filterCategory.name === "Providers" ? "gradient" : "contained"
                                  }
                                  container
                                />
                              </div>
                            ))
                          : "-"}
                      </div>
                    )}
                  </Grid>
                </Grid>
                <Divider />
              </div>
            ))}
            <Grid
              key={accordionItem.id + "-button-holder"}
              item
              xs={3}
              style={{ textAlign: "right" }}
            >
              <Button
                //disabled={accordionItem.unused ? true : selected === "panel" + accordionItem.id}
                disabled={true}
                color={selected === "panel" + accordionItem.id ? "primary" : "success"}
                size="small"
                variant="gradient"
                onClick={(e) => handleSelect(e, accordionItem)}
              >
                preview
              </Button>
              <SoftButton
                color="success"
                size="small"
                variant="gradient"
                onClick={(e) => handleSave(e, accordionItem)}
                disabled={accordionItem.unused}
              >
                Save
              </SoftButton>
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}

// Typechecking props for the DataTable
ControlledAccordions.propTypes = {
  data: PropTypes.array,
  handleChangeConfiguration: PropTypes.func,
};

export default ControlledAccordions;
